<!-- @veltra/icons generated sha256:b66a13a23f0eef9c gen:8 source:src/svg/normal/triangle-alert.svg -->
<script setup lang="ts">
defineOptions({ name: 'TriangleAlert' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path
      d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4m0 4h.01"
    />
  </svg>
</template>
